import React, { useEffect, useState } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { selectRep } from "../../redux-store/rep/repSlice";
import { useAppSelector, useAppDispatch } from "../../store";

type Product = {
  prodname?: string;
};

const MainMenu = (props: Product) => {
  const dispatch = useAppDispatch();
  const { data: rep, status } = useAppSelector(selectRep);

  const [url, setUrl] = useState("");

  //destructuring pathname from location
  const { pathname } = useLocation();

  const isActive = (to: string) => {
    return pathname.replace(/\/\d+$/, "") + ((searchParams.toString() != "") ? "?" + searchParams.toString() : "") === to.replace(/\/\d+$/, "");
  };

  const [searchParams] = useSearchParams();

  useEffect(() => {
    setUrl(rep!.repFolder + ((searchParams.toString() != "") ? "?" + searchParams.toString() : ""));
  }, [url, rep]);

  return (
    <nav className="navbar navbar-expand-lg order-lg-2">
      <button
        className="navbar-toggler d-block d-lg-none"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span />
      </button>
      {/* End mobile collapse menu */}

      <div className="collapse navbar-collapse" id="navbarNav">
        <ul className="navbar-nav">
          <li className="d-block d-lg-none">
            <div className="logo">
              <Link to={"/home/" + url} className="d-block">
                <img src="/images/logo/UWE_PP_Logo.webp" alt="logo" />
              </Link>
            </div>
          </li>
          {/* End li */}
          <li className="nav-item">
            <Link
              to={"/home/" + url}
              className={
                isActive("/") ||
                  isActive("/home") ||
                  isActive("/home/" + url)
                  ? "nav-link active-menu"
                  : "nav-link"
              }
            >
              Home
            </Link>
          </li>
          {/* End li (pages) */}
          <li className="nav-item">
            <Link
              to={"/whatsincluded/" + url}
              className={
                isActive("/whatsincluded") ||
                  isActive("/whatsincluded/" + url) ||
                  isActive("/creditrestoration") ||
                  isActive("/creditrestoration/" + url) ||
                  isActive("/creditmonitoring") ||
                  isActive("/creditmonitoring/" + url) ||
                  isActive("/creditanalysis") ||
                  isActive("/creditanalysis/" + url) ||
                  isActive("/creditattorney") ||
                  isActive("/creditattorney/" + url) ||
                  isActive("/yflfamilymint") ||
                  isActive("/yflfamilymint/" + url) ||
                  isActive("/budgeting") ||
                  isActive("/budgeting/" + url) ||
                  isActive("/networth") ||
                  isActive("/networth/" + url) ||
                  isActive("/debtpayoff") ||
                  isActive("/debtpayoff/" + url) ||
                  isActive("/willandtrust") ||
                  isActive("/willandtrust/" + url) ||
                  isActive("/identitymonitoring") ||
                  isActive("/identitymonitoring/" + url) ||
                  isActive("/financiallockbox") ||
                  isActive("/financiallockbox/" + url) ||
                  isActive("/rocketlawyer") ||
                  isActive("/rocketlawyer/" + url) ||
                  isActive("/savingsgoals") ||
                  isActive("/savingsgoals/" + url)
                  ? "nav-link active-menu"
                  : "nav-link"
              }
            >
              What's Included
            </Link>
          </li>
          {/* End li (pages) */}

          <li className="nav-item">
            <Link
              to={"/testimonial/" + url}
              className={
                isActive("/testimonial") ||
                  isActive("/testimonial/" + url)
                  ? "nav-link active-menu"
                  : "nav-link"
              }
            >
              Testimonial
            </Link>
          </li>
          {/* End li (pages) */}
          {url !== "" && (
            <li className="nav-item">
              <Link
                to={"/ppquizhome/" + url}
                className={
                  isActive("/ppquizhome") || isActive("/ppquizhome/" + url)
                    ? "nav-link active-menu"
                    : "nav-link"
                }
              >
                Financial Quiz
              </Link>
            </li>
          )}
          <li className="nav-item">
            <Link
              to={"/contactus/" + url}
              className={
                isActive("/contactus") ||
                  isActive("/contactus/" + url)
                  ? "nav-link active-menu"
                  : "nav-link"
              }
            >
              Contact Us
            </Link>
          </li>
          {/* End li (pages) */}
        </ul>
        {/* End ul */}

        {/* Mobile Content */}
        <div className="mobile-content d-block d-lg-none">
          <div className="d-flex flex-column align-items-center justify-content-center mt-70">
            <Link
              className="align-items-center btn-one text-white fw-500 tran3s d-flex"
              type="button"
              id="langDropdown" to="https://portal.ucesprotectionplan.com/"
              target="_blank"                >
              <img
                src="/images/icon/icon_62.svg"
                alt="icon"
                className="me-2 h-auto w-auto"
              />
              Login
            </Link>
            {/* <button
              className="dropdown-toggle align-items-center btn-one text-white fw-500 tran3s d-flex"
              type="button"
              id="langDropdown"
              data-bs-toggle="dropdown"
              data-bs-auto-close="true"
              aria-expanded="false"
            >
              <img
                src="/images/icon/icon_62.svg"
                alt="icon"
                className="me-2 h-auto w-auto"
              />
              Login
            </button>
            <ul className="dropdown-menu fs-13 position-relative" aria-labelledby="langDropdown">
              <li>
                <Link to="https://portal.ucesprotectionplan.com/" target={"_blank"} className="dropdown-item">
                  New Portal
                </Link>
              </li>
              <li>
                <Link to="https://ucespp.memberaccount.net" target={"_blank"} className="dropdown-item">
                  Old Portal
                </Link>
              </li>
            </ul> */}
          </div>
        </div>
        {/* /.mobile-content */}
      </div>
    </nav>
  );
};

export default MainMenu;
